"use client";
import { Button } from "react-bootstrap";
import { baseUrl } from "utils/constants";

export default function BlankPage() {
  return (

	<div className="cp_right">
		<div className="cpr_content d-flex flex-column flex-grow-1">
			<div className="flex-grow-1 align-self-center content_center w-100 align-items-center align-content-center">
				{/* placeholder for middle content */}
			</div>
			
			<div className="input_bar">
				<div className="ml-auto mr-auto">
					
					<div className="row">
						<div className="col-3 pb-4">
				
							<div className="cardv2 cardv2--portrait">
								<div className="cardv2--portrait__header">
								<div className="cardv2--portrait__header_agent">
									<a className="agent_signaturev2" href="https://www.har.com/shadrick-bogany/agent_BOGANYS">
									<div className="agent_signaturev2__photo" title="View Michel Hayek's profile" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/573025.jpg?ts=2024-06-26T13:18:00")'}} />
									<div className="agent_signaturev2__info">
										<div className="agent_signaturev2__info__agent_name" title="View Michel Hayek's profile" aria-label="View Michel Hayek's profile">
										Michel Hayek
										</div>
										<div className="agent_signaturev2__info__broker_name" title="View Better Homes And Gardens Real's page" aria-label="View Better Homes And Gardens Real's page">
										Better Homes And Gardens Real
										</div>
									</div>
									</a>
								</div>
								<div className="cardv2--portrait__header_controls">
									<button type="button" className="btn btn--icon--borderless btn--icon btn--icon--favorite" />									
								</div>
								</div>
								{/* / card header */}
								{/* card img */}
								<a href="#">
								<div className="cardv2--portrait__img" style={{backgroundImage: 'url(https://photos.harstatic.com/298573103/hr/img-1.jpeg?ts=2024-09-14T23:39:23.527)'}} />
								</a>
								{/* / card img */}
								{/* card body */}
								<a href="#">
								<div className="cardv2--portrait__body">
									<div className="cardv2--portrait__body_flexrow">
									<div className="cardv2--portrait__body_price">$7,009,00</div>
									<div className="cardv2--portrait__body_status"><div className="label label--forsale">Active</div></div>
									</div>
									<div className="cardv2--portrait__body_flexrow">
									<div className="cardv2--portrait__body_address">
										14302 Laurus Estates Lane<br />
										Cypress, TX 77429
									</div>						
									</div>
								</div>
								</a>
								{/* / card img */}
							</div>

						</div>
						
						
						<div className="col-3 pb-4">
				
							<div className="cardv2 cardv2--portrait">
								<div className="cardv2--portrait__header">
								<div className="cardv2--portrait__header_agent">
									<a className="agent_signaturev2" href="https://www.har.com/shadrick-bogany/agent_BOGANYS">
									<div className="agent_signaturev2__photo" title="View Michel Hayek's profile" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/573025.jpg?ts=2024-06-26T13:18:00")'}} />
									<div className="agent_signaturev2__info">
										<div className="agent_signaturev2__info__agent_name" title="View Michel Hayek's profile" aria-label="View Michel Hayek's profile">
										Michel Hayek
										</div>
										<div className="agent_signaturev2__info__broker_name" title="View Better Homes And Gardens Real's page" aria-label="View Better Homes And Gardens Real's page">
										Better Homes And Gardens Real
										</div>
									</div>
									</a>
								</div>
								<div className="cardv2--portrait__header_controls">
									<button type="button" className="btn btn--icon--borderless btn--icon btn--icon--favorite" />									
								</div>
								</div>
								{/* / card header */}
								{/* card img */}
								<a href="#">
								<div className="cardv2--portrait__img" style={{backgroundImage: 'url(https://photos.harstatic.com/298573103/hr/img-2.jpeg?ts=2024-09-14T23:39:23.527)'}} />
								</a>
								{/* / card img */}
								{/* card body */}
								<a href="#">
								<div className="cardv2--portrait__body">
									<div className="cardv2--portrait__body_flexrow">
									<div className="cardv2--portrait__body_price">$7,009,00</div>
									<div className="cardv2--portrait__body_status"><div className="label label--forsale">Active</div></div>
									</div>
									<div className="cardv2--portrait__body_flexrow">
									<div className="cardv2--portrait__body_address">
										14302 Laurus Estates Lane<br />
										Cypress, TX 77429
									</div>						
									</div>
								</div>
								</a>
								{/* / card img */}
							</div>
																		
						</div>




						<div className="col-3 pb-4">
				
							<div className="cardv2 cardv2--portrait">
								<div className="cardv2--portrait__header">
								<div className="cardv2--portrait__header_agent">
									<a className="agent_signaturev2" href="https://www.har.com/shadrick-bogany/agent_BOGANYS">
									<div className="agent_signaturev2__photo" title="View Michel Hayek's profile" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/573025.jpg?ts=2024-06-26T13:18:00")'}} />
									<div className="agent_signaturev2__info">
										<div className="agent_signaturev2__info__agent_name" title="View Michel Hayek's profile" aria-label="View Michel Hayek's profile">
										Michel Hayek
										</div>
										<div className="agent_signaturev2__info__broker_name" title="View Better Homes And Gardens Real's page" aria-label="View Better Homes And Gardens Real's page">
										Better Homes And Gardens Real
										</div>
									</div>
									</a>
								</div>
								<div className="cardv2--portrait__header_controls">
									<button type="button" className="btn btn--icon--borderless btn--icon btn--icon--favorite" />									
								</div>
								</div>
								{/* / card header */}
								{/* card img */}
								<a href="#">
								<div className="cardv2--portrait__img" style={{backgroundImage: 'url(https://photos.harstatic.com/298573103/hr/img-3.jpeg?ts=2024-09-14T23:39:23.527)'}} />
								</a>
								{/* / card img */}
								{/* card body */}
								<a href="#">
								<div className="cardv2--portrait__body">
									<div className="cardv2--portrait__body_flexrow">
									<div className="cardv2--portrait__body_price">$7,009,00</div>
									<div className="cardv2--portrait__body_status"><div className="label label--forsale">Active</div></div>
									</div>
									<div className="cardv2--portrait__body_flexrow">
									<div className="cardv2--portrait__body_address">
										14302 Laurus Estates Lane<br />
										Cypress, TX 77429
									</div>						
									</div>
								</div>
								</a>
								{/* / card img */}
							</div>
																		
						</div>



						<div className="col-3 pb-4">
				
							<div className="cardv2 cardv2--portrait">
								<div className="cardv2--portrait__header">
								<div className="cardv2--portrait__header_agent">
									<a className="agent_signaturev2" href="https://www.har.com/shadrick-bogany/agent_BOGANYS">
									<div className="agent_signaturev2__photo" title="View Michel Hayek's profile" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/573025.jpg?ts=2024-06-26T13:18:00")'}} />
									<div className="agent_signaturev2__info">
										<div className="agent_signaturev2__info__agent_name" title="View Michel Hayek's profile" aria-label="View Michel Hayek's profile">
										Michel Hayek
										</div>
										<div className="agent_signaturev2__info__broker_name" title="View Better Homes And Gardens Real's page" aria-label="View Better Homes And Gardens Real's page">
										Better Homes And Gardens Real
										</div>
									</div>
									</a>
								</div>
								<div className="cardv2--portrait__header_controls">
									<button type="button" className="btn btn--icon--borderless btn--icon btn--icon--favorite" />									
								</div>
								</div>
								{/* / card header */}
								{/* card img */}
								<a href="#">
								<div className="cardv2--portrait__img" style={{backgroundImage: 'url(https://photos.harstatic.com/298573103/hr/img-4.jpeg?ts=2024-09-14T23:39:23.527)'}} />
								</a>
								{/* / card img */}
								{/* card body */}
								<a href="#">
								<div className="cardv2--portrait__body">
									<div className="cardv2--portrait__body_flexrow">
									<div className="cardv2--portrait__body_price">$7,009,00</div>
									<div className="cardv2--portrait__body_status"><div className="label label--forsale">Active</div></div>
									</div>
									<div className="cardv2--portrait__body_flexrow">
									<div className="cardv2--portrait__body_address">
										14302 Laurus Estates Lane<br />
										Cypress, TX 77429
									</div>						
									</div>
								</div>
								</a>
								{/* / card img */}
							</div>
																		
						</div>

					</div>
					
				</div>
				
				<div className="input_main_container">
					<div className="input_text_bar">
						<input type="text" className="input_text_bar_text form-control" />
						<button type="button" className="btn btn--primary btn--large input_text_bar_btn d-flex align-items-center" disabled><span>Submit</span><img className="ml-3" src="https://content.harstatic.com/media/icons/copilot/ai_node_arrow.svg" /></button>
					</div>
					<div className="footer_disclaimer font_size--small_extra color_auxiliary text-center pt-2 d-md-block d-none">
						HAR.AI may produce inaccurate information about listings, market, or facts. 
						<a className="color_auxiliary" href="#">HAR.AI Privacy Notice</a>
					</div>
					<div className="footer_disclaimer font_size--small_extra_extra color_auxiliary text-center pt-2 d-md-none d-block">
						HAR.AI may provide inaccurate details. Check <a className="color_auxiliary" href="#">HAR.AI Privacy Notice</a>
					</div>
				</div>
			</div>
		</div>
	</div>	
  );
}
